import React from 'react';
import FormContact from '../partials/FormContact';
import API from '../../configAPI';
class Advertise extends React.Component{
        constructor(props){
        super(props);
        this.state = {
            providers: {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
             providers1: {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
             providers2: {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
            text_query: '',
            loading: true
        }

    }
    componentDidMount(){
        this.getProviders();
        this.getProviders1();
        this.getProviders2();
        window.scrollTo(0,0);
    }
     getProviders = () => {
       API.PRODUCTS(`providersp`)
        .then(resp =>{
            this.setState({
                providers : resp.data,
                loading: !this.state.loading
            });

        })
        .catch(err =>{
            this.setState({
                loading: !this.state.loading
            });
            console.log(err);
        });
    }
    getProviders1 = () => {
       API.PRODUCTS(`providersp1`)
        .then(resp =>{
            this.setState({
                providers1 : resp.data,
                loading: !this.state.loading
            });

        })
        .catch(err =>{
            this.setState({
                loading: !this.state.loading
            });
            console.log(err);
        });
    }
    getProviders2 = () => {
       API.PRODUCTS(`providersp2`)
        .then(resp =>{
            this.setState({
                providers2 : resp.data,
                loading: !this.state.loading
            });

        })
        .catch(err =>{
            this.setState({
                loading: !this.state.loading
            });
            console.log(err);
        });
    }
    render(){
        return(
            <div className="container-fluid mt-2 mb-3">
              {/*<section className="col-12">
              <h4 className="text-center">¡Publica tus productos!</h4>
                <p className="text-center">Confíe su campaña de marketing a Arquiproductos.com, ya que sus productos y/o servicios llegarán directamente a su público objetivo, en el momeno exacto cuando tengan requerimientos para sus obras, permitiéndoles además llegar antes que su competencia.</p>
                <p className="text-center"><a href="#solicitar" className="btn btn-secondary btn-lg mb-2">Solicite información</a></p>                 
                <div className="text-center"><img src="http://beta.pullcreativo.com/img/devices.jpg" className="img-fluid" alt="Desde cualquier dispositivo"/></div>
            </section>*/}

            {/* <section className="col-12 mt-5">
                <h4 className="text-center">17.1 Millones de usuarios registrados</h4>
                <p className="text-center"> El número más alto de visitantes y profesionales registrados en todo el mundo </p>
                <div className="text-center"><img src="http://beta.pullcreativo.com/img/map.jpg" className="img-fluid" alt="Ubicaciones"/></div>
            </section>

            <section className="col-12 mt-5">
                <h4 className="text-center">80% de diseñadores y 20% de comercio</h4>
                <p className="text-center"> El tráfico web y los usuarios registrados siempre crecen </p>
                <div className="text-center"><img src="http://beta.pullcreativo.com/img/analytics.jpg" className="img-fluid" alt="Estadísticas" /></div>
                <div className="row px-4 mt-3">
                <div className="cd-xs-12 col-md-3 text-center"> <h4>46 Millones</h4> <p>de Visitas / Año</p> </div>
                <div className="cd-xs-12 col-md-3 text-center"> <h4>28 Millones</h4> <p>Visitantes únicos / Año</p> </div>
                <div className="cd-xs-12 col-md -3 text-center"> <h4>144 Millones</h4> <p>Impresiones / año</p> </div>
                <div className="cd-xs-12 col-md-3 text-center"> <h4>4.5 Millones</h4> <p>de seguidores</p> </div>
                </div>
            </section> */}



                <div className="col-12">
                <h5 className="text-center font-weight-bold">El futuro del comercio de productos para la Arquitectura</h5>
                <p className="text-center">ARQUIPRODUCTOS hace que sea más fácil para los clientes encontrar y comprar sus productos</p>
                <p className="text-center">Solicite información o llámenos al <strong>(01) 463-4070</strong></p>
                    <FormContact/>
                </div>
                <br></br>
                <div class=" mb-3" >
                  <div class="row no-gutters">
                    
                    <div class="col-md-6">
                      <div class="card-body ">
                        <div class="cmt-5" style={{margin: "8.5% 0 0 0"}}>
                        <h3 class="card-title text-center">ARQUIPRODUCTOS es la forma más fácil de llegar a más clientes</h3>
                        <br></br>
                        <p class="card-text text-center">Al construir un escaparate en ARQUIPRODUCTOS, tiene instantáneamente las últimas capacidades de marketing digital y comercio electrónico.</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <img src="/assets/imagen1.png" class="card-img"  alt="imagen"></img>
                    </div>
                  </div>
                </div>

                <br></br><br></br>

                  <h4 className="text-center font-weight-bold">Con la confianza de las principales empresas de nuestra industria</h4>
                    
                    <div class="card-deck col-10 mx-auto">
                   <div className="row">
                    {this.state.providers.data.map((prov,index) =>(

                      <div class="card mx-auto" key={index} >
                        <a href={`/empresa/${prov.slug}`} class="text-center"><img src={prov.url_logo} class="card-img-top mx-auto" alt="..." style={{width:"70%"}}></img></a>
                        
                      </div>
                        ))}
                    </div>
                     
                    </div>
                    <br></br>
                    <div class="card-deck col-10 mx-auto">
                   <div className="row">
                    {this.state.providers1.data.map((prov,index) =>(

                      <div class="card mx-auto" key={index} >
                        <a href={`/empresa/${prov.slug}`} class="text-center"><img src={prov.url_logo} class="card-img-top mx-auto" alt="..." style={{width:"70%"}}></img></a>
                        
                      </div>
                        ))}
                    </div>
                     
                    </div>
                    

                    
                   <br></br> <br></br>

                    <h4 className="text-center font-weight-bold">Transformación digital instantánea del cliente</h4>
                    <div class="col-10 mx-auto"> 
                    <img src="/assets/imagen2.png" class="card-img-top" alt="..."></img>
                    </div>


                    <div class="card-deck col-10 mx-auto">
                      <div class="card" style={{border:"none"}}>
                        
                        <div class="card-body">
                          <h5 class="card-title text-center">BUSCAR</h5>
                          <p class="card-text text-center">Los clientes pueden encontrar fácilmente su escaparate en línea y navegar por todo su catálogo de productos.</p>
                          
                        </div>
                      </div>
                      <div class="card" style={{border:"none"}}>
                       
                        <div class="card-body">
                          <h5 class="card-title text-center">APRENDER</h5>
                          <p class="card-text text-center">Los clientes pueden aprender fácilmente sobre sus productos, descargar literatura técnica y enviar mensajes a su equipo de ventas.</p>
                      
                        </div>
                      </div>
                      <div class="card" style={{border:"none"}}>
                       
                        <div class="card-body">
                          <h5 class="card-title text-center">COMPRAR</h5>
                          <p class="card-text text-center">Los clientes pueden solicitar presupuestos, negociar términos y realizar sus pedidos en línea, que se envían directamente a su empresa.</p>

                        </div>
                      </div>
                    </div>

                      <br></br><br></br>

                    <div class="col-8 mx-auto">
                    <h4 className="text-center font-weight-bold">Hay más de 2000 productos, en más de 70 empresas actualmente en ARQUIPRODUCTOS</h4>
                    </div>


                   

                    <div class="col-10 mx-auto">
                     <div class="row row-cols-1 row-cols-md-3">
                    {this.state.providers2.data.map((prov,index) =>(
                     
                      <div class="card" key={index} >
                        <div class="row">
                         <div class="col-md-4">
                         <a href={`/empresa/${prov.slug}`} class="text-center"><img src={prov.url_logo} class="card-img mx-auto" style={{margin:"15% 0 0 0"}} alt="..."></img></a>
                                                  
                          </div>
                           <div class="col-md-8">
                          <div class="card-body">
                            <h5 class="card-title text-center">{prov.name}</h5>
                            <p class="card-text text-center">{prov.products_count} productos</p>
                                                    
                           </div>
                           </div>

                        </div>
                         </div>
                       
                        ))}
                          </div>
                    </div>


                    <div class="col-12 mx-auto">
                    <p class="text-center" style={{margin:"2% 0 0 0"}} ><a  class="btn btn-dark" href="/empresas" style={{color:"white"}}>Ver Todos</a></p>
                    </div>
                    <br></br><br></br>


                     <h4 className="text-center font-weight-bold">Las características de su tienda</h4>
                    
                    <div class="card-deck col-10 mx-auto">
                      <div class="card" style={{border:"none"}}>
                        <img src="/assets/tienda.jpg" class="card-img-top mx-auto" alt="..." style={{width:"30%"}}></img>
                        <div class="card-body">
                          <h5 class="card-title text-center">Tienda de Marca</h5>
                          <p class="card-text text-center">Su tienda dedicada para su empresa en ARQUIPRODUCTOS, que se vea y se sienta como su marca.</p>
                          
                        </div>
                      </div>
                      <div class="card" style={{border:"none"}}>
                       <img src="/assets/busqueda.jpg" class="card-img-top mx-auto" alt="..." style={{width:"30%"}}></img>
                        <div class="card-body">
                          <h5 class="card-title text-center">Búsqueda y filtros</h5>
                          <p class="card-text text-center">Una vez en su tienda, los clientes pueden explorar fácilmente su catálogo de productos y encontrar el producto.</p>
                      
                        </div>
                      </div>
                      <div class="card" style={{border:"none"}}>
                       <img src="/assets/gestion.jpg" class="card-img-top mx-auto" alt="..." style={{width:"30%"}}></img>
                        <div class="card-body">
                          <h5 class="card-title text-center">Gestión y contenido</h5>
                          <p class="card-text text-center">Cambie fácilmente el diseño de su tienda, agregue nuevo contenido y edite fácilmente la información de su producto.</p>

                        </div>
                      </div>

                    </div>

                    <div class="card-deck col-10 mx-auto">
                      <div class="card" style={{border:"none"}}>
                        <img src="/assets/compromiso.jpg" class="card-img-top mx-auto" alt="..." style={{width:"30%"}}></img>
                        <div class="card-body">
                          <h5 class="card-title text-center">Compromiso con el cliente</h5>
                          <p class="card-text text-center">Envía mensajes y chatea con tus clientes mientras están en tu tienda.</p>
                          
                        </div>
                      </div>
                      <div class="card" style={{border:"none"}}>
                       <img src="/assets/marketing.jpg" class="card-img-top mx-auto" alt="..." style={{width:"30%"}}></img>
                        <div class="card-body">
                          <h5 class="card-title text-center">Automatización de marketing</h5>
                          <p class="card-text text-center">Envíe notificaciones automáticas y correos electrónicos a los clientes que visitan su tienda.</p>
                      
                        </div>
                      </div>
                      <div class="card" style={{border:"none"}}>
                       <img src="/assets/ecommerce.jpg" class="card-img-top mx-auto" alt="..."  style={{width:"30%"}}></img>
                        <div class="card-body">
                          <h5 class="card-title text-center">eCommerce</h5>
                          <p class="card-text text-center">Negocie precios de forma privada y permita a los clientes realizar sus pedidos con facilidad.</p>

                        </div>
                      </div>

                    </div>


                    <h3 className="text-center font-weight-bold">Cómo funciona</h3>
                    <p className="text-center font-weight-bold">Lanza su tienda con ARQUIPRODUCTOS</p>

                    <div class="col-8 mx-auto">
                        <div class=" mb-3" >
                              <div class="row no-gutters">
                                <div class="col-md-2">
                                  <img src="/assets/organizar.jpg" class="card-img" alt="..."  style={{width:"80%"}}></img>
                                </div>
                                <div class="col-md-10">
                                  <div class="card-body">
                                    <h5 class="card-title">Organizar</h5>
                                    <p class="card-text">Arquiproductos organiza todo el contenido de su producto en línea.</p>
                                    
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class=" mb-3" >
                              <div class="row no-gutters">
                                <div class="col-md-2">
                                  <img src="/assets/construir.jpg" class="card-img" alt="..." style={{width:"80%"}}></img>
                                </div>
                                <div class="col-md-10">
                                  <div class="card-body">
                                    <h5 class="card-title">Construir</h5>
                                    <p class="card-text">Arquiproductos construye automáticamente su tienda, incluidas las páginas de su marca y producto.</p>
                                    
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class=" mb-3" >
                              <div class="row no-gutters">
                                <div class="col-md-2">
                                  <img src="/assets/contribuir.jpg" class="card-img" alt="..." style={{width:"80%"}}></img>
                                </div>
                                <div class="col-md-10">
                                  <div class="card-body">
                                    <h5 class="card-title">Contribuir</h5>
                                    <p class="card-text">Puede contribuir fácilmente más contenido del producto a su tienda e invitar a su equipo de ventas a responder las preguntas de los clientes.</p>
                                    
                                  </div>
                                </div>
                              </div>
                        </div>
                         <div class=" mb-3" >
                              <div class="row no-gutters">
                                <div class="col-md-2">
                                  <img src="/assets/marketplace.jpg" class="card-img" alt="..."  style={{width:"80%"}}></img>
                                </div>
                                <div class="col-md-10">
                                  <div class="card-body">
                                    <h5 class="card-title">Marketplace</h5>
                                    <p class="card-text">Arquiproductos maneja todo lo demás, desde SEO hasta Analytics. Llevamos clientes potenciales a usted.</p>
                                    
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class=" mb-3" >
                              <div class="row no-gutters">
                                <div class="col-md-2">
                                  <img src="/assets/contratar.jpg" class="card-img" alt="..."  style={{width:"80%"}}></img>
                                </div>
                                <div class="col-md-10">
                                  <div class="card-body">
                                    <h5 class="card-title">Contratar</h5>
                                    <p class="card-text">Una vez que los clientes estén en su tienda, ¡genere clientes potenciales más fáciles que nunca!</p>
                                    
                                  </div>
                                </div>
                              </div>
                        </div>
                       

                    </div>



                        <h3 className="text-center font-weight-bold">Preguntas frecuentes</h3>

                        <div class="row row-cols-1 row-cols-md-2 col-10 mx-auto">
                        <div class="row mx-auto">
                          <div class="card-body col-10">
                                                    
                           <h5>¿Qué es un marketplace?</h5>
                                <p>Piense en su propio sitio web como una tienda independiente. Piense en un marketplace como un centro comercial o una feria comercial. Casi todos los productos en la tierra ahora se pueden encontrar en un marketplace. Esta misma experiencia ahora está llegando a productos químicos e ingredientes.</p>
                                
                                <h5>¿Por qué necesito ARQUIPRODUCTOS si ya tengo mi propio sitio web?</h5>
                                <p>En el mundo de hoy, tener un sitio web no es suficiente. Incluso si invierte mucho en su sitio, es imposible canalizar a todos los clientes potenciales en la web a su sitio. ¿Las marcas famosas como Nike solo venden sus productos en su propio sitio web? Por supuesto no.</p>
                                
                                <h5>¿Cómo encuentran mis clientes nuestra tienda en ARQUIPRODUCTOS?</h5>
                                <p>Los clientes pueden encontrar su tienda en ARQUIPRODUCTOS, Google y buscando en cualquier otro motor de búsqueda importante.</p>
                                
                           </div>
                        </div>
                        <div class="row">
                          <div class="card-body col-10">
                                 <h5>¿Por qué unirse a un marketplace?</h5>
                                <p>En el mundo B2C, los marketplaces (como Amazon) han cambiado la forma en que investigamos y compramos. Más del 50% de todas las ventas en línea ocurren en marketplaces. Esta misma tendencia ahora está llegando a B2B. Pronto, así es como sus clientes exigirán trabajar con usted.</p>

                                <h5>¿En qué se diferencia ARQUIPRODUCTOS de otros marketplaces?</h5>
                                <p>ARQUIPRODUCTOS fue creado a propósito para productos de construcción. Entendemos sus necesidades únicas y creamos una solución a medida.</p>
                                <br></br>
                                <h5>¿Cuánto cuesta ARQUIPRODUCTOS?</h5>
                                <p>ARQUIPRODUCTOS es la forma más rápida y económica de construir su presencia en línea. Solicite una demostración para obtener más información.</p>
                                                    
                          
                                
                           </div>
                        </div>
 
                        </div>

                    <div class="mx-auto text-center">
                    <a class="text-center" target="_blank" href="http://plataforma.constructivo.com/arquitectura"><img src="/assets/plataforma728x90.jpg" class="img-fluid mx-auto" alt="..." ></img></a>
                    </div>

            </div>
        )
    }
}

export default Advertise;
